import commonMutations from '@/store/ui/common/mutations'
import Vue from 'vue'
import { cloneDeep, find, isNil, findIndex, uniq } from 'lodash'

const mutations = {
    ...commonMutations,
    setPreviousRoute(state, { route }) {
        Vue.set(state, 'previousRoute', route)
    },
    setGeneralSetting(state, { type, activate }) {
        Vue.set(state.general, type, activate)
    },
    setSocioDemoSetting(state, { type, activate }) {
        Vue.set(state.sociodemo, type, activate)
    },
    setDataMiningSetting(state, { type, activate }) {
        Vue.set(state.dataMining, type, activate)
    },
    setSettingName(state, { name }) {
        Vue.set(state, 'settingName', name)
    },
    setWamFactoSetting(state, { type, activate }) {
        Vue.set(state.wamFactory, type, activate)
    },
    resetUiDataminingSettings(state, { settings }) {
        Vue.set(state, 'dataMining', cloneDeep(settings))
    },

    // extra-taxo
    setTotalActiveTaxos(state, { activeTaxo }) {
        Vue.set(state.extraTaxo, 'activeTaxo', activeTaxo)
    },
    setExtraTaxos(state, { items }) {
        const extraTaxos = cloneDeep(items)
        if (extraTaxos['default'] && extraTaxos['default'][0] && extraTaxos['default'][0]['label'] === 'gt') {
            extraTaxos['default'][0]['label'] = 'Weborama General Taxonomy'
        }
        Vue.set(state.extraTaxo, 'list', extraTaxos)
    },
    resetExtraTaxos(state, { previousExtraTaxos }) {
        Vue.set(state, 'extraTaxo', previousExtraTaxos)
    },

    setExtraTaxoIsLoading(state, { isLoading }) {
        Vue.set(state.extraTaxo, 'isLoading', isLoading)
    },

    updateExtraTaxo(state, { taxoToUpdate, status }) {
        // special management for the default webo taxo that is stored in wb not default
        if (taxoToUpdate.owner === 'wb' && taxoToUpdate.taxonomy === 'gt') {
            taxoToUpdate.owner = 'default'
        }

        const _taxoToUpdate = find(state.extraTaxo.list[taxoToUpdate.owner], taxo => taxo.label === taxoToUpdate.label)
        if (!isNil(_taxoToUpdate) && _taxoToUpdate !== undefined) {
            Vue.set(_taxoToUpdate, 'status', status)
        }
    },

    updateExtraTaxoCounter(state, { status }) {
        // updating the activetaxos for ui
        const activeTaxo = state.extraTaxo.activeTaxo
        if (status === 'active') {
            Vue.set(state.extraTaxo, 'activeTaxo', activeTaxo + 1)
        } else if (status === 'inactive') {
            Vue.set(state.extraTaxo, 'activeTaxo', activeTaxo - 1)
        }
    },

    setExtraTaxoNewLabel(state, { taxo, currentLabel, newLabel }) {
        let owner = taxo.owner
        if (taxo.owner === 'wb' && taxo.taxonomy === 'gt') {
            owner = 'default'
        }
        const _taxoToUpdate = find(state.extraTaxo.list[owner], taxo => taxo.label === currentLabel)
        if (!isNil(_taxoToUpdate) && _taxoToUpdate !== undefined) Vue.set(_taxoToUpdate, 'label', newLabel)
    },

    // Sharing

    setActiveSharing(state, { sharingId, action, indexToDelete }) {
        if (action === 'add') {
            const selectedSharing = uniq([...state.sharing.activeSharing, sharingId])
            Vue.set(state.sharing, 'activeSharing', selectedSharing)
        } else if (action === 'remove') {
            Vue.delete(state.sharing.activeSharing, indexToDelete)
        }
    },
    setSharingToAdd(state, { sharingId, action }) {
        const indexToRemove = findIndex(state.sharing.sharingToAdd, item => item === sharingId)
        if (action === 'add') {
            const sharingToAdd = uniq([...state.sharing.sharingToAdd, sharingId])
            Vue.set(state.sharing, 'sharingToAdd', sharingToAdd)
        } else if (action === 'remove') {
            Vue.delete(state.sharing.sharingToAdd, indexToRemove)
        }
    },
    setSharingToRemove(state, { sharingId, action }) {
        const indexToRemove = findIndex(state.sharing.sharingToRemove, item => item === sharingId)
        if (action === 'add') {
            const sharingToRemove = uniq([...state.sharing.sharingToRemove, sharingId])
            Vue.set(state.sharing, 'sharingToRemove', sharingToRemove)
        } else if (action === 'remove') {
            Vue.delete(state.sharing.sharingToRemove, indexToRemove)
        }
    },
    resetSharings(state) {
        Vue.set(state.sharing, 'sharingToRemove', [])
        Vue.set(state.sharing, 'sharingToAdd', [])
    },
    setDefaultActiveSharing(state, { alreadyActiveSharing }) {
        Vue.set(state.sharing, 'activeSharing', alreadyActiveSharing)
    },
    setSharingType(state, { sharingType }) {
        Vue.set(state.sharing, 'sharingType', sharingType)
    },
    /**
     * 
     * @param {Object} state 
     * @param {Boolean} payload 
     */
    setLoading(state, payload){
        state.sharing.isLoading = payload
    }
}

export default mutations
